import React from 'react';
import './AdminBadge.css';

/**
 * @param {{
 *   tone?: 'critical' | 'signal' | 'ambient' | 'ok' | 'neutral' | 'brand',
 *   children?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminBadge({ tone = 'neutral', children, className = '' }) {
  return (
    <span className={`au-badge au-scope au-badge--${tone}${className ? ` ${className}` : ''}`}>
      <span className="au-badge__dot" aria-hidden="true" />
      <span>{children}</span>
    </span>
  );
}

export default AdminBadge;
